import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

export const fetchSchoolYears = createAsyncThunk(
  'schoolYears/fetch',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/settings/school-years/`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to fetch school years');
    }
  }
);

export const updateSchoolYear = createAsyncThunk(
  'schoolYears/update',
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/settings/school-years/${id}/`, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to update school year');
    }
  }
);

export const createSchoolYear = createAsyncThunk(
  'schoolYears/create',
  async (data, thunkAPI) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/settings/school-years/`, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to create school year');
    }
  }
);

export const deactivateSchoolYears = createAsyncThunk(
  'schoolYears/deactivate',
  async (_, thunkAPI) => {
    try {
      const res = await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/settings/school-years/deactivate/`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to deactivate school years');
    }
  }
);


const schoolYearsSlice = createSlice({
  name: 'schoolYears',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolYears.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolYears.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(createSchoolYear.fulfilled, (state, action) => {
  state.list = [action.payload];  // ✅ overwrite with the latest only
})
    
      .addCase(updateSchoolYear.fulfilled, (state, action) => {
  const index = state.list.findIndex(year => year.id === action.payload.id);
  if (index !== -1) {
    state.list[index] = action.payload;
  }
})
      .addCase(fetchSchoolYears.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default schoolYearsSlice.reducer;
